<!-- 退出确认弹窗 -->
<template>
  <div class="exit-confirmation">
    <van-overlay :show="show" @click="show = false" :lock-scroll="true">
      <div class="wrapper" @click.stop>
        <div class="content">
          <div class="title">小主确定要退出活动吗？</div>
          <div class="tip">
            {{ "  " }}
            <!-- 国行APP首页搜索“如E随行”可以快速找到<br />回来的路哦~ -->
          </div>
          <div class="btn-box">
            <img
              class="btn"
              @click="closeWindow"
              :src="
                require(`@/assets/imgs/xiamenBankAscendGold/ascend_gold47.png`)
              "
              alt=""
            />
            <img
              class="btn"
              @click="close"
              :src="
                require(`@/assets/imgs/xiamenBankAscendGold/ascend_gold48.png`)
              "
              alt=""
            />
          </div>

          <br />
          <!-- <img class="close" @click="close" :src="require(`@/assets/imgs/xiamenBankAscendGold/ascend_gold3.png`)" alt=""> -->
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import { toEventHomePage } from './community'
export default {
  components: {},
  props: ['type'],
  data() {
    return {
      show: false
    }
  },
  computed: {

  },
  methods: {
    // 银行app关闭网页
    closeWindow() {
      // eslint-disable-next-line no-undef
      XIBLS.closeWindow()
    },
    close() {
      this.setShow(false)
    },
    setShow(val) {
      this.show = val
    },
    toEventHomePage() {
      console.log('去活动首页');
      toEventHomePage()
    }
  },
}
</script>
<style lang="less">
.exit-confirmation {
  position: relative;
  z-index: 99;

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .content {
    width: 300px;
    height: 325px;
    box-sizing: border-box;
    background: url("../../../../assets/imgs/xiameBankDepositStandard/popup.png")
      no-repeat;
    background-size: cover;
    text-align: center;
    padding: 142px 0 0 0;
    position: relative;

    .close-icon {
      position: absolute;
      right: 20px;
      top: 95px;
      font-size: 24px;
      color: #bababa;
    }

    .title {
      padding-top: 20px;
      font-size: 19px;
      line-height: 2.4;
      font-weight: bold;
      color: #822603;
    }

    .tip {
      font-size: 13px;
      color: #9a4f2f;
      line-height: 1.3;
    }
    .btn-box {
      margin: 30px 20px;
      display: flex;
      align-items: center;
      justify-content: space-around;
    }
    .btn {
      width: 112px;
    }

    .close {
      margin: 25px 0;
      width: 32px;
    }
  }
}
</style>
